import { IGetDefaultValueIndex } from '../types';

// We need to determine which index in the list options is the active id. So when the dropdown
// is opened we can scroll and show that as the current selected option.
// This is determined by the defaultValue of the select input and the 'value' in the options
const getDefaultValueIndex: IGetDefaultValueIndex = ({ defaultValue, options }) => {
  const index = options.findIndex(({ value }) => value === defaultValue?.toString());

  if (!defaultValue || index === -1) return 0;
  return index;
};

export { getDefaultValueIndex };
